require('./brokerIntervenerItem.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
// @ commons
const OKSelect = require('components/commons/OKSelect/OKSelect');
const { OKButton } = require('components/commons/OKButton/OKButton');
// @ helpers
const { formatText } = require('core/i18n').i18n;
const classNames = require('classnames');
const { recordLink } = require("utilities/tagging");
// @ constants
const {
    ACCOUNT_INTERVENTION_AUTHORIZED_CODE,
    ACCOUNT_INTERVENTION_REPRESENTATIVE_CODE,
    INTERVENER_LABEL_HOLDER,
    INTERVENER_LABEL_AUTHORIZED,
    INTERVENER_LABEL_EMPOWERED,
    INTERVENER_LABEL_LEGAL_REPRESENTATIVE,
    INTERVENER_LABEL_ADMINISTRATOR
} = require('constants/index');
const { DELETE_ACTION_EVENT, OPEN_ACTION_EVENT } = require('constants/tagging');
const { COUNTRIES_CODES: { ES } } = require('constants/countries');
const { INTERVENER_CODES } = require('constants/interveners');

class BrokerIntervenerItem extends React.Component {

    constructor(props) {
        super(props);
        this.handleIntervenerNameChange = this.handleIntervenerNameChange.bind(this);
        this.handleIntervenerTypeChange = this.handleIntervenerTypeChange.bind(this);
        this.handleRemoveIntervener = this.handleRemoveIntervener.bind(this);
        this.renderIntervenerName = this.renderIntervenerName.bind(this);
    }

    handleIntervenerNameChange(e) {
        const { index, onIntervenerNameChange } = this.props;
        onIntervenerNameChange(index, e.value)
    }

    handleIntervenerTypeChange(e) {
        const { index, onIntervenerTypeChange } = this.props;
        onIntervenerTypeChange(index, e.value)
    }

    handleRemoveIntervener() {
        const { index, onIntervenerRemove, customCategoryEvent } = this.props;
        onIntervenerRemove(index);
        recordLink(customCategoryEvent || window.utag_last_name, 'interviniente ' + (index + 1) , DELETE_ACTION_EVENT);
    }

    renderIntervenerName(){
        const { originalInterveners, intervenerName, isOnlyIntervener, isAdditionalSubscription, isOwner } = this.props;

        const intervenersSelect = originalInterveners.map((item) => {
            return {
                label: item.get('name'),
                value: item.get('name')
            }
        });

        const nameLabel = formatText('broker-stockIntervenerItemNameLabel');

        if (this.props.nameLabelFormat){
            return (
                <div className="intervener-item__label-wrapper">
                    <label>{intervenerName}</label>
                </div>
                );
        } else {
           return (
               <div className="intervener-item__name-wrapper">
                   <OKSelect
                       label={nameLabel}
                       name="advanced-search-product"
                       className="intervener-item__select intervener-item__select--first"
                       options={intervenersSelect.toJS()}
                       value={intervenerName}
                       onChange={this.handleIntervenerNameChange}
                       clearable={false}
                       searchable={false}
                       placeholder="Selecciona un interviniente"
                       disabled={isOwner || isOnlyIntervener || isAdditionalSubscription}/>
               </div>);
        }
    }

    render() {
        const typeLabel = formatText('broker-stockIntervenerItemTypeLabel');
        const {
            hierarchicalTypeSelection,
            index,
            intervenerOptions,
            intervenerOriginalTypeNumber,
            intervenerType,
            isOnlyOwner,
            removeIconChildren,
            useIntervenerCode,
            isAdditionalSubscription,
            isOwner,
            customCategoryEvent
        } = this.props;

        let intervenerOptionsForDropdown = intervenerOptions;

        // I remove options from the dropdown according to the intervener's role
        if (hierarchicalTypeSelection) {
            // There are no breaks on purpose for this switch, so the roles are removed hierarchically by the order of the cases
            switch (intervenerOriginalTypeNumber){
                 // On top goes the case for the role with the lowest hierarchy, so all other roles should be removed from the dropdown
                 // An intervener with Representative role can't be set as an Authorized or Holder intervener
                case ACCOUNT_INTERVENTION_REPRESENTATIVE_CODE:
                    // We remove the inmediate superior role and let the execution fall to the other cases
                    intervenerOptionsForDropdown = intervenerOptionsForDropdown.filter(type => type != INTERVENER_LABEL_AUTHORIZED);

                // An authorized intervener can't be a holder
                case ACCOUNT_INTERVENTION_AUTHORIZED_CODE:
                    intervenerOptionsForDropdown = intervenerOptionsForDropdown.filter(type => type != INTERVENER_LABEL_HOLDER);

                // PENDING: Add cases with the rest of the roles in ascending hierarchy when they're needed.
                // Use these constants: ACCOUNT_INTERVENTION_LEGAL_REPRESENTATIVE_CODE, ACCOUNT_INTERVENTION_OWNER_CODE
            }
        }

        const options = intervenerOptionsForDropdown.map(label => {
            const text = formatText(`brokerIntevenerItem-${label}`);
            const value = useIntervenerCode ? INTERVENER_CODES[label] : formatText(`brokerIntevenerItem-${label}`, [], ES.toLowerCase()).toUpperCase();
            return {
                value,
                label: text
            };
        });

        const iconCrossClassName = classNames('intervener-item__icon-cross', {
            'intervener-item__icon-cross--hidden': isOnlyOwner
        });
        const removeIcon = this.props.showRemoveIcon ?
        (
            <div className={iconCrossClassName} >
                <OKButton
                    modifier="ghost"
                    onClick={this.handleRemoveIntervener}
                    leftIcon="icon-cross"
                >
                    {removeIconChildren}
                </OKButton>
            </div>
        ) :
        null;

        const typeWrapperClassName = classNames('intervener-item__type-wrapper', {
            'intervener-item__type-wrapper--small': removeIconChildren
        });

        return (
            <div className="intervener-item clearfix">
                {this.renderIntervenerName()}
                <div className={typeWrapperClassName}>
                    <OKSelect
                        label={typeLabel}
                        name="advanced-search-product"
                        className="intervener-item__select"
                        options={options}
                        value={intervenerType}
                        onChange={this.handleIntervenerTypeChange}
                        clearable={false}
                        searchable={false}
                        showLabel={true}
                        disabled={isOwner || isOnlyOwner || isAdditionalSubscription}
                        onOpen={() => recordLink(customCategoryEvent || window.utag_last_name, 'interviniente ' + (index + 1) , OPEN_ACTION_EVENT)}
                    />
                </div>
                {removeIcon}
            </div>
        );
    }
}

BrokerIntervenerItem.defaultProps = {
    originalInterveners: [],
    isOnlyIntervener: false,
    isOnlyOwner: false,
    nameLabelFormat: true,
    showInterventionLabel: false,
    showRemoveIcon: false,
    showRemoveLabel: false,
    intervenerOptions: [
        INTERVENER_LABEL_HOLDER,
        INTERVENER_LABEL_AUTHORIZED,
        INTERVENER_LABEL_LEGAL_REPRESENTATIVE,
        INTERVENER_LABEL_ADMINISTRATOR,
        INTERVENER_LABEL_EMPOWERED
    ],
    hierarchicalTypeSelection: false,
    useIntervenerCode: false,
    isAdditionalSubscription: false,
    customCategoryEvent: null
};

BrokerIntervenerItem.propTypes = { // alphabetically ordered
    hierarchicalTypeSelection: PropTypes.bool,
    index: PropTypes.number,
    intervenerName: PropTypes.string,
    intervenerOptions: PropTypes.arrayOf(PropTypes.oneOf([
        INTERVENER_LABEL_HOLDER,
        INTERVENER_LABEL_AUTHORIZED,
        INTERVENER_LABEL_LEGAL_REPRESENTATIVE,
        INTERVENER_LABEL_ADMINISTRATOR,
        INTERVENER_LABEL_EMPOWERED
    ])),
    intervenerOriginalTypeNumber: PropTypes.string,
    intervenerType: PropTypes.string.isRequired,
    isOnlyIntervener: PropTypes.bool,
    isOnlyOwner: PropTypes.bool,
    nameLabelFormat: PropTypes.bool,
    onIntervenerNameChange: PropTypes.func,
    onIntervenerTypeChange: PropTypes.func,
    onIntervenerRemove: PropTypes.func,
    originalInterveners: PropTypes.object,
    removeIconChildren: PropTypes.object,
    useIntervenerCode: PropTypes.bool,
    showInterventionLabel: PropTypes.bool,
    showRemoveIcon: PropTypes.bool,
    showRemoveLabel: PropTypes.bool,
    isAdditionalSubscription: PropTypes.bool,
    isOwner: PropTypes.bool,
    customCategoryEvent: PropTypes.string
};

module.exports = BrokerIntervenerItem;
